skrilla.directive('querySkrPurchases', function () {
    return {
        templateUrl: 'directives/querySkrPurchases/querySkrPurchases.html',
        scope: {
            purchases: "=",
            key: "="
        },
        controller: function ($scope, searchService, queryService, paginationService, cacheService) {
            $scope.reset = function () {
                $scope.query = {
                    userId: "",
                    transactionReference: "",
                    aud: false,
                    usd: false,
                    limit: 20
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getPurchases, $scope.key);
            }

            var getPurchases = function () {
                return searchService.get("exchange/purchases" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.purchases = response.data.result;
                    cacheService.registerObject("skrPurchasesTable", $scope.purchases);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
